import { FC } from 'react';

import CopyToClipboardButton from '@features/copy-to-clipboard-button';
import { Tooltip } from '@mui/material';

interface IProps {
  name: string;
  value: string;
  tooltip?: string;
  hasCopyBtn?: boolean;
}

const InputReadOnlyWithOptionalCopy: FC<IProps> = ({ name, value, tooltip, hasCopyBtn }) => {
  const input = <input type='text' name={name} value={value} disabled />;

  return (
    <>
      {tooltip ? (
        <Tooltip title={tooltip} placement='top'>
          <span style={{ display: 'block' }}>{input}</span>
        </Tooltip>
      ) : input}
      {hasCopyBtn && <CopyToClipboardButton text={value} size='small' />}
    </>
  );
};

export { InputReadOnlyWithOptionalCopy };
